import { AppDetailsState } from '../../../slices/appDetails';

/**
 * Helper function - retrieve Staff and partnerId
 * @param state Helper function identify the partnerId
 */
export const getAppDetails = ({ groups }: AppDetailsState) => ({
  isStaff: groups.includes('staff'),
  affinityId: groups.filter((g) => g !== 'staff')[0],
});
